const KEY = "mlm_vault_messages";

export function getVault() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function addToVault(message) {
  const list = getVault();
  list.unshift(message);
  localStorage.setItem(KEY, JSON.stringify(list));
}

export function removeFromVault(code) {
  const list = getVault().filter((m) => m.code !== code);
  localStorage.setItem(KEY, JSON.stringify(list));
}
